import { Platform, StyleSheet } from 'react-native';

import { C } from '../../../../common';
import { THEME } from '../../../../reactor/common';

const {
  BORDER_RADIUS, COLOR, UNIT, OFFSET,
} = THEME;

export default StyleSheet.create({
  container: {
    ...C.PAGE_CONTENT,
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  centered: {
    justifyContent: 'center',
  },

  textStandalone: {
    maxWidth: '52.5%',
  },

  box: {
    backgroundColor: COLOR.WHITE,
    borderRadius: BORDER_RADIUS,
  },

  button: {
    marginTop: OFFSET,
  },

  reverse: {
    flexDirection: 'row-reverse',
  },

  rights: {
    marginTop: UNIT,
    alignSelf: 'flex-end',
  },

  imageFirst: {
    marginBottom: OFFSET,
    ...Platform.select({
      web: {
        order: -1,
      },
    }),
  },

  title: {
    marginTop: OFFSET / 2,
    marginBottom: OFFSET,
  },
});
